// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout-module--layout--3Pyz6","layout__inner":"Layout-module--layout__inner--3VqcN","layout__body":"Layout-module--layout__body--2DC6G"};